import React from 'react';

export default function ScrollSliderItem({ blok }) {
  return (
    <div>
      scroll slider item
    </div>
  );
}
